module.exports = __webpack_public_path__ + "img/04-more-button.71344584.png";